import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function DownloadIconTextToImage(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 12 13" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
				<path
					d="M0.625001 9.29152L0.625001 10.6248C0.625001 10.9784 0.765477 11.3176 1.01553 11.5676C1.26557 11.8177 1.60471 11.9581 1.95833 11.9581L9.95833 11.9581C10.312 11.9581 10.6511 11.8177 10.9011 11.5676C11.1512 11.3176 11.2917 10.9784 11.2917 10.6248L11.2917 9.29152M2.625 5.29159L5.95833 8.62487M5.95833 8.62487L9.29167 5.29159M5.95833 8.62487L5.95833 0.625"
					stroke="var(--primary-text-color)"
					stroke-width="1.25"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
}

export default DownloadIconTextToImage;
